/* FR Makeover: Header-Suche + Live-Vorschläge (fr-search-ui.js / fr-search.css) auf jeder Seite nachladen.
   Version bei Änderungen an diesen Dateien hochzählen (Cache). Shopifys CDN beachtet nur den Parameter v=. */
(function () {
  var FR_V = '15';
  var me = document.currentScript;
  if (!me || !me.src || window.__frSearchUiLoader) return;
  window.__frSearchUiLoader = true;
  var base = me.src.split('?')[0].replace(/sidebar-menu-search\.js$/, '');
  if (!document.querySelector('link[href*="fr-search.css"]')) {
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = base + 'fr-search.css?v=fr' + FR_V;
    document.head.appendChild(l);
  }
  var s = document.createElement('script');
  s.src = base + 'fr-search-ui.js?v=fr' + FR_V;
  s.defer = true;
  document.head.appendChild(s);
})();

document.addEventListener('DOMContentLoaded', () => {
  const input       = document.getElementById('SidebarSearchInput');
  const rootPane    = document.getElementById('menu-root');
  const searchPane  = document.getElementById('menu-search');
  const suggList    = document.getElementById('SearchSuggestions');
  const backBtn     = document.getElementById('SearchPaneBack');
  if (!input || !rootPane || !searchPane) return;
  let debounce;
  let requestId = 0;

  /* ----- Handles ---------------------------------------------------- */
  const cardPrd = document.getElementById('CardProducts');
  const cardCol = document.getElementById('CardCollections');
  const cardArt = document.getElementById('CardArticles');

  const listPrd = cardPrd.querySelector('ul');
  const listCol = cardCol.querySelector('ul');
  const listArt = cardArt.querySelector('ul');
  const cardStatic    = document.getElementById('CardStatic');      // Häufig gesucht
  const cardBest      = document.getElementById('CardBestseller');  // Bestseller

  /* Sample-Filter */
  const SAMPLE_RE = /^sample\s*-\s*/i;

  /* FR Makeover: Teilwort-Suche ("retino" findet "Retinol") */
  const searchUrl = q => `/search?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last`;

  /* ---------- Pane-Switch ---------- */
  function activate(pane){
    const rootActive   = pane === rootPane;
    const searchActive = pane === searchPane;

    rootPane.classList.toggle('is-active', rootActive);
    rootPane.classList.toggle('is-left',  !rootActive);
    searchPane.classList.toggle('is-active', searchActive);

    rootPane .setAttribute('aria-hidden', !rootActive);
    searchPane.setAttribute('aria-hidden', !searchActive);
  }

  /* Fokus ⇒ Suche öffnen */
  input.addEventListener('focus', () => activate(searchPane));

  /* Back-Button ⇒ zurück zum Root-Pane */
  backBtn.addEventListener('click', () => {
    input.value = '';
    suggList.innerHTML = '';
    resetCards();
    cardStatic.hidden = false;
    renderStatic();
    activate(rootPane);
    input.blur();
  });

  /* Escape ⇒ gleiches Verhalten wie Back-Button */
  input.addEventListener('keydown', e => {
    if (e.key === 'Escape') backBtn.click();
  });

  input.addEventListener('keydown', e => {
    if (e.key === 'Enter'){
      const q = input.value.trim();
      if (q) location.href = searchUrl(q);
    }
  });

  input.addEventListener('input', () => {
    clearTimeout(debounce);
    const q = input.value.trim();

    /* Kein Text ⇒ Static-Cards bleiben */
    if (!q){
      resetCards();
      cardStatic.hidden = false;
      cardBest.hidden   = false;
      renderStatic();
      return;
    }
    cardStatic.hidden = true;
    cardBest.hidden   = true;

    debounce = setTimeout(async () => {
      const myId = ++requestId;
      const enc = encodeURIComponent(q);
      const jsonUrl = `/search/suggest.json?q=${enc}&resources[type]=product,article&resources[limit]=6&resources[options][unavailable_products]=last`;
      /* FR Makeover: Kategorien nur mit Metafeld "In der Suche anzeigen" (sections/fr-predictive-search.liquid) */
      const colUrl  = `/search/suggest?q=${enc}&resources%5Btype%5D=collection&resources%5Blimit%5D=10&section_id=fr-predictive-search`;

      let data = null, colHtml = '';
      try {
        const [jsonRes, colRes] = await Promise.all([
          fetch(jsonUrl, { headers:{'X-Requested-With':'XMLHttpRequest'} }),
          fetch(colUrl)
        ]);
        data = await jsonRes.json();
        colHtml = colRes.ok ? await colRes.text() : '';
      } catch (err) { return; }
      if (myId !== requestId) return; // veraltete Antwort ignorieren
      resetCards();

      /* ---------- Produkte ---------- */
      const products = ((data && data.resources.results.products) || [])
                        .filter(p => !SAMPLE_RE.test(p.title));
      if (products.length){
        listPrd.innerHTML = products.map(p =>
          `<li><a class="MenuCard__Link" href="${p.url}">
                <img src="${p.image}" width="32" height="32" style="vertical-align:middle;border-radius:4px;margin-right:.5rem;">
                ${p.title}
            </a></li>`
        ).join('');
        cardPrd.hidden = false;
      }

      /* ---------- Kollektionen (gefiltert) ---------- */
      if (colHtml){
        const doc = new DOMParser().parseFromString(colHtml, 'text/html');
        const cols = Array.from(doc.querySelectorAll('[data-fr-ps-collections] a'));
        if (cols.length){
          listCol.innerHTML = cols.map(a =>
            `<li><a class="MenuCard__Link" href="${a.getAttribute('href')}">${a.textContent}</a></li>`
          ).join('');
          cardCol.hidden = false;
        }
      }

      /* ---------- Artikel ---------- */
      const arts = (data && data.resources.results.articles) || [];
      if (arts.length){
        listArt.innerHTML = arts.map(a =>
          `<li><a class="MenuCard__Link" href="${a.url}">${a.title}</a></li>`
        ).join('');
        cardArt.hidden = false;
      }

      /* Falls gar nichts kam – Static wieder zeigen */
      if (cardPrd.hidden && cardCol.hidden && cardArt.hidden){
        cardStatic.hidden = false;
        renderStatic();
      }
    }, 250);
  });

  /* Renderer */
  const STATIC = ['Vitamin C Serum','Hyaluron','Retinol','Sonnenschutz','Anti-Aging','Akne','Faltencreme','Cleanser','Augencremes'];
  function render(arr){
    suggList.innerHTML = arr.map(t =>
      `<li><button class="MenuCard__Link" data-q="${t}">${t}</button></li>`
    ).join('');
  }
  suggList.addEventListener('click', e => {
    const b = e.target.closest('button[data-q]');
    if (b) location.href = searchUrl(b.dataset.q);
  });
  const renderStatic = () => render(STATIC);
  renderStatic();

  function resetCards(){
    [cardPrd, cardCol, cardArt].forEach(card => {
      card.hidden = true;
      card.querySelector('ul').innerHTML = '';
    });
  }
});

/* Produktart × Marke: Markenschalter im Burger-Menü (snippets/fr-menu.liquid).
   Zeigt je Marke die Produktzahl, graut leere Produktarten aus, merkt sich die Wahl für die Browsersitzung. */
document.addEventListener('DOMContentLoaded', function () {
  var box = document.querySelector('[data-fr-box="produktart"]');
  if (!box) return;
  var NAMES = { a: 'IMAGE', b: 'iS Clinical' };
  var heading = box.querySelector('[data-fr-pa-heading]');
  function apply(brand) {
    box.setAttribute('data-fr-brand', brand);
    box.querySelectorAll('[data-fr-seg]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-fr-seg') === brand ? 'true' : 'false');
    });
    box.querySelectorAll('.fr-Tile--pa').forEach(function (t) {
      t.setAttribute('href', t.getAttribute('data-href-' + brand));
      var n = brand === 'all' ? '' : (t.getAttribute('data-n-' + brand) || '0');
      var tag = t.querySelector('[data-fr-brandtag]');
      var cnt = t.querySelector('[data-fr-count]');
      if (tag) tag.textContent = brand === 'all' ? '' : NAMES[brand];
      if (cnt) cnt.textContent = n ? '(' + n + ')' : '';
      t.classList.toggle('is-empty', brand !== 'all' && n === '0');
    });
    if (heading) heading.textContent = brand === 'all' ? heading.getAttribute('data-label-all') : 'Produktart · ' + NAMES[brand];
    try { sessionStorage.setItem('frMenuBrand', brand); } catch (e) {}
  }
  box.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fr-seg]');
    if (b) apply(b.getAttribute('data-fr-seg'));
  });
  var saved = '';
  try { saved = sessionStorage.getItem('frMenuBrand') || ''; } catch (e) {}
  if (saved === 'a' || saved === 'b') apply(saved);
});
/* Produktart: 6 Kacheln sichtbar, Rest aufklappen (snippets/fr-menu.liquid).
   Merkt sich „aufgeklappt“ für die Browsersitzung; Aufklappen wird in der Menü-Messung als m-pa-mehr gezählt. */
document.addEventListener('DOMContentLoaded', function () {
  var tiles = document.querySelector('[data-fr-pa-tiles]');
  var btn = document.querySelector('[data-fr-pa-more]');
  if (!tiles || !btn) return;
  var label = btn.querySelector('[data-fr-pa-more-label]');
  function set(open) {
    tiles.classList.toggle('is-collapsed', !open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (label) label.textContent = open ? 'Weniger anzeigen' : 'Alle Produktarten anzeigen';
    try { sessionStorage.setItem('frMenuPaOpen', open ? '1' : '0'); } catch (e) {}
  }
  btn.addEventListener('click', function () {
    var open = tiles.classList.contains('is-collapsed');
    set(open);
    if (open && window.FRT) FRT.track('m-pa-mehr');
  });
  var saved = '';
  try { saved = sessionStorage.getItem('frMenuPaOpen') || ''; } catch (e) {}
  if (saved === '1') set(true);
});

/* Drawer-Fix iOS: Seite hinter dem Burger-Menü wirklich einfrieren (overflow:hidden reicht auf WebKit nicht).
   Beim Öffnen body fixieren und Scrollposition merken, beim Schließen exakt dort weitermachen – kein Sprung, nichts scheint durch. */
document.addEventListener('DOMContentLoaded', function () {
  var menu = document.getElementById('sidebar-menu');
  if (!menu) return;
  var savedY = 0, locked = false;
  function lock() {
    if (locked) return;
    locked = true;
    savedY = window.pageYOffset || 0;
    var b = document.body.style;
    b.position = 'fixed'; b.top = (-savedY) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
  }
  function unlock() {
    if (!locked) return;
    locked = false;
    var b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    window.scrollTo(0, savedY);
  }
  new MutationObserver(function () {
    if (menu.getAttribute('aria-hidden') === 'false') lock(); else unlock();
  }).observe(menu, { attributes: true, attributeFilter: ['aria-hidden'] });
  window.addEventListener('pagehide', unlock);
});
/* Burger-Menü Desktop (3/4 Breite): Boxen in 3 Spalten gruppieren. CSS: assets/fr-menu.css („Desktop-Menü 3/4“).
   Mobil sind die Spalten unsichtbar (display:contents), die Reihenfolge kommt dort aus CSS order. */
document.addEventListener('DOMContentLoaded', function () {
  var nav = document.querySelector('#sidebar-menu .fr-Menu');
  if (!nav || nav.querySelector('.fr-Menu__Col')) return;
  var COLS = { a: ['konto', 'alle', 'marken', 'hilfe'], b: ['produktart', 'image-linien'], c: ['angebote', 'wissen', 'service'] };
  Object.keys(COLS).forEach(function (k) {
    var col = document.createElement('div');
    col.className = 'fr-Menu__Col fr-Menu__Col--' + k;
    COLS[k].forEach(function (name) {
      var box = nav.querySelector(':scope > [data-fr-box="' + name + '"]');
      if (box) col.appendChild(box);
    });
    nav.appendChild(col);
  });
});